{
  "network.title": "Nätverk",
  "network.subtitle.one": "{count} verkstad",
  "network.subtitle.other": "{count} verkstäder",
  "network.nav.overview": "Översikt",
  "network.nav.kpi": "Nyckeltal",
  "network.nav.demand": "Efterfrågan",
  "network.nav.health": "Systemhälsa",
  "network.nav.audit": "Revisionslogg",
  "network.error": "Vi kunde inte hämta nätverksdatan.",
  "network.empty": "Inget att visa för det här urvalet.",
  "network.readonly": "Läsläge. Allt som ändras här görs genom att logga in som någon på verkstaden.",
  "network.data_as_of": "Siffrorna räknades om {when}",
  "network.data_as_of.never": "Siffrorna har inte räknats om ännu",
  "network.data_as_of.hint": "Räknas om varje timme.",
  "network.filter.country": "Land",
  "network.filter.country.all": "Alla länder",
  "network.filter.franchise": "Verkstad",
  "network.filter.franchise.all": "Alla verkstäder",
  "network.filter.service": "Tjänst",
  "network.filter.service.all": "Alla tjänster",
  "network.filter.range": "Period",
  "network.filter.reset": "Rensa filter",
  "network.range.7": "7 dagar",
  "network.range.30": "30 dagar",
  "network.range.90": "90 dagar",
  "network.range.365": "12 månader",
  "network.compared_to": "Jämfört med {from} – {to}",
  "network.export": "Exportera CSV",
  "network.export.hint": "Öppnas i Excel med de filter som är aktiva.",
  "network.map.title": "Karta",
  "network.map.planned": "Planerad marknad",
  "network.map.locations.one": "{count} verkstad",
  "network.map.locations.other": "{count} verkstäder",
  "network.map.legend": "Färgen visar dagens beläggning. Ring runt pricken betyder öppen varning.",
  "network.column.next_open": "Nästa lediga dag",
  "network.column.alerts": "Varningar",
  "network.location.load": "{booked} av {capacity} h bokat idag",
  "network.location.no_capacity": "Stängt idag",
  "network.location.next_open": "Nästa lediga dag {date}",
  "network.location.next_open.none": "Fullbokad så långt vi ser",
  "network.location.open": "Öppna verkstaden",
  "network.alert.integration_degraded": "Kalendersynk ur funktion",
  "network.alert.notifications_failing": "Utskick misslyckas",
  "network.alert.awaiting_approval": "Väntar på bekräftelse",
  "network.alert.overbooked": "Överbokad",
  "network.alerts.none": "Inga varningar",
  "network.metric.bookings": "Bokningar",
  "network.metric.revenue": "Intäkt",
  "network.metric.utilisation": "Beläggning",
  "network.metric.no_show_rate": "Uteblivna",
  "network.metric.cancellation_rate": "Avbokningar",
  "network.metric.lead_time": "Ledtid",
  "network.metric.job_value": "Snittordervärde",
  "network.metric.first_response": "Svarstid besiktning",
  "network.metric.not_applicable": "Går inte att räkna per tjänst",
  "network.metric.no_data": "Ingen data",
  "network.delta.better": "{value} bättre än föregående period",
  "network.delta.worse": "{value} sämre än föregående period",
  "network.delta.flat": "Oförändrat mot föregående period",
  "network.delta.none": "Ingen jämförelse",
  "network.chart.title": "{metric} per dag",
  "network.chart.current": "Vald period",
  "network.chart.previous": "Föregående period",
  "network.chart.table": "Visa som tabell",
  "network.chart.date": "Datum",
  "network.league.title": "Ligatabell",
  "network.league.metric": "Sortera på",
  "network.league.column.rank": "Plats",
  "network.league.column.name": "Verkstad",
  "network.league.column.country": "Land",
  "network.league.column.value": "Värde",
  "network.league.column.trend": "Trend",
  "network.league.column.delta": "Förändring",
  "network.demand.title": "Efterfrågekarta",
  "network.demand.hint": "Underlag för var nästa verkstad ska öppna. Innehåller inga personuppgifter.",
  "network.demand.postcodes": "Per postnummer",
  "network.demand.services": "Per tjänst",
  "network.demand.unservable": "Kunde inte bokas någonstans",
  "network.demand.unservable.hint": "En förfrågan som ingen verkstad kunde ta har inget land, så den här listan visas bara för HQ.",
  "network.demand.column.postcode": "Postnummer",
  "network.demand.column.attempts": "Försök",
  "network.demand.column.matched": "Matchade",
  "network.demand.column.unservable": "Utan verkstad",
  "network.demand.column.converted": "Bokade",
  "network.demand.column.service": "Tjänst",
  "network.demand.column.no_slot": "Ingen tid",
  "network.demand.column.nearest": "Närmaste verkstad",
  "network.demand.column.distance": "Avstånd",
  "network.demand.column.last_seen": "Senast",
  "network.health.delivery": "E-postleverans",
  "network.health.delivery_rate": "Levererat",
  "network.health.sent": "Skickade",
  "network.health.failed": "Misslyckade",
  "network.health.pending": "Väntande",
  "network.health.bounced": "Studsade",
  "network.health.window_24h": "Senaste dygnet",
  "network.health.window_7d": "Senaste veckan",
  "network.health.queues": "Köer",
  "network.health.queues.unavailable": "Kön kan inte läsas härifrån. Se docs/DEPLOYMENT.md.",
  "network.health.queues.hidden": "Köerna är nätverksövergripande och visas bara för HQ.",
  "network.health.integrations": "Integrationer per verkstad",
  "network.health.integrations.none": "Inga kalendrar är anslutna ännu.",
  "network.health.api": "API",
  "network.health.api.caveat": "Räknas i minnet, per process, sedan {since}. Nollställs vid varje driftsättning.",
  "network.health.api.requests": "Anrop",
  "network.health.api.error_rate": "Felkvot",
  "network.health.api.slowest": "Långsammaste vägar",
  "network.health.failed_jobs": "Misslyckade utskick",
  "network.health.column.queue": "Kö",
  "network.health.column.route": "Väg",
  "network.health.column.p95": "p95",
  "network.health.column.attempts": "Försök",
  "network.health.column.error": "Fel",
  "network.health.all_clear": "Inget att åtgärda.",
  "network.audit.filter.entity": "Objekt",
  "network.audit.filter.action": "Åtgärd",
  "network.audit.filter.all": "Alla",
  "network.audit.column.when": "Tidpunkt",
  "network.audit.column.action": "Åtgärd",
  "network.audit.column.entity": "Objekt",
  "network.audit.column.actor": "Utförd av",
  "network.audit.column.franchise": "Verkstad",
  "network.audit.column.ip": "IP",
  "network.audit.impersonated": "via {email}",
  "network.audit.system": "Systemet",
  "network.audit.more": "Visa fler",
  "network.detail.settings": "Inställningar",
  "network.detail.staff": "Personal och resurser",
  "network.detail.notifications": "Utskick, 30 dagar",
  "network.detail.integrations": "Integrationer",
  "network.detail.hours": "Öppettider",
  "network.detail.closed": "Stängt",
  "network.detail.confirm.auto": "Bekräftas automatiskt",
  "network.detail.confirm.manual": "Bekräftas manuellt",
  "network.detail.notice": "Kortaste varsel",
  "network.detail.horizon": "Bokningsbart {days} dagar fram",
  "network.detail.granularity": "Tidssteg {minutes} min",
  "network.detail.cancellation": "Avbokning till {hours} h innan",
  "network.detail.services": "{enabled} av {total} tjänster påslagna",
  "network.detail.calendar": "Öppna kalendern",
  "network.detail.back": "Tillbaka till nätverket",
  "network.detail.no_staff": "Ingen personal upplagd ännu.",
  "network.create.open": "Ny verkstad",
  "network.create.title": "Lägg upp en verkstad",
  "network.create.body": "Tidszon, språk och valuta följer av landet. Verkstaden läggs upp under uppstart och syns inte i bokningen förrän den aktiveras.",
  "network.create.identity": "Verkstaden",
  "network.create.identity_body": "Namnet kunderna ser, och uppgifterna som mejlen och fakturorna bygger på.",
  "network.create.place": "Plats",
  "network.create.place_body": "Var kunden möter verkstaden — på kartan och i sökningen efter närmaste verkstad.",
  "network.create.optional": "frivilligt",
  "network.create.country": "Land",
  "network.create.country_hint": "Bestämmer tidszon, språk och valuta. Går inte att ändra efteråt.",
  "network.create.display_name_hint": "Namnet kunden ser i bokningen, på kartan och i mejlen.",
  "network.create.slug": "Adressnamn",
  "network.create.slug_hint": "Ligger i bokningslänken och i varje mejl som skickats. Välj rätt från början.",
  "network.create.slug_preview": "Bokningslänken blir /boka/{slug} och går inte att ändra efteråt.",
  "network.create.legal_name": "Juridiskt namn",
  "network.create.legal_name_hint": "Bolagsnamnet. Syns aldrig för kunden.",
  "network.create.org_nr": "Organisationsnummer",
  "network.create.mode": "Typ av verksamhet",
  "network.create.mode.fixed": "Fast verkstad",
  "network.create.mode.mobile": "Ambulerande",
  "network.create.mode.hybrid": "Både fast och ambulerande",
  "network.create.mode_hint.fixed": "Kunden kommer hit. Gatuadressen måste fyllas i.",
  "network.create.mode_hint.mobile": "Teknikern åker till kunden. Adressen är utgångspunkten och är frivillig — radien nedan avgör vem som kan boka.",
  "network.create.mode_hint.hybrid": "Kunden kan komma hit och teknikern kan åka ut. Radien nedan avgör hur långt ni åker.",
  "network.create.geo": "Koordinater",
  "network.create.geo_hint": "Klistra in båda talen på en gång i Latitud, så delar vi upp dem. Vi slår inte upp adresser — kartan och sökningen efter närmaste verkstad bygger på de här två talen.",
  "network.create.hours_copy": "Kopiera {day} till alla öppna dagar",
  "network.create.missing": "Kvar att fylla i:",
  "network.create.services_note": "Hela tjänstekatalogen slås på till nätverkets priser. Verkstaden justerar själv efteråt.",
  "network.create.submit": "Lägg upp verkstaden",
  "network.create.created": "{name} är upplagd. Bjud in ägaren och aktivera när allt står rätt.",
  "network.create.error": "Det gick inte att lägga upp verkstaden.",
  "network.create.slug_taken": "Adressnamnet är upptaget.",
  "network.create.check_fields": "Kontrollera de markerade fälten.",
  "network.create.invalid": "Kontrollera det här fältet.",
  "network.create.slug_format": "Bara a–z, 0–9 och bindestreck. Inga å, ä, ö eller mellanslag.",
  "network.unit.hours": "{count} h",
  "network.unit.minutes": "{count} min",
  "network.unit.days": "{count} d",
  "network.unit.percent": "{value} %",
  "network.status.onboarding": "Under uppstart",
  "network.status.paused": "Verkstaden är borttagen från bokningen.",
  "network.status.paused_with_bookings": "Verkstaden är borttagen från bokningen. {count} bokade tider står kvar och måste hanteras.",
  "network.status.activated": "Verkstaden är igång och syns i bokningen.",
  "network.status.activate": "Aktivera verkstaden",
  "network.status.needs_staff": "Lägg upp minst en bokningsbar person eller enhet innan verkstaden aktiveras.",
  "network.status.error": "Det gick inte att ändra status.",
  "network.danger.title": "Riskzon",
  "network.danger.body": "Ta bort verkstaden från bokningen. Den försvinner från hitta-verkstad och kan inte bokas, men kalender, historik och siffror finns kvar.",
  "network.danger.paused_body": "Verkstaden är borttagen från bokningen. Aktivera den igen när den ska ta emot kunder.",
  "network.danger.remove": "Ta bort från bokningen",
  "network.danger.confirm_title": "Ta bort verkstaden från bokningen?",
  "network.danger.confirm_body": "Kunder kan inte längre hitta eller boka den här verkstaden. Redan bokade tider avbokas inte — ring kunderna. Inget raderas och du kan aktivera verkstaden igen.",
  "network.danger.type_slug": "Skriv {slug} för att bekräfta",
  "network.status.removed": "Borttagen från bokningen",
  "network.danger.copy_slug": "Kopiera {slug}",
  "network.danger.copied": "Namnet är kopierat.",
  "network.column.status": "Status",
  "network.status.active": "I drift",
  "network.reports.title": "Rapporter till dig",
  "network.reports.body": "Få nätverkets eller ett lands siffror mejlade automatiskt.",
  "network.reports.scope": "Omfattning",
  "network.reports.scope.network": "Hela nätverket",
  "network.reports.self_only": "Rapporten skickas till din egen adress.",
  "network.nav.reports": "Rapporter",
  "network.nav.integrations": "Integrationer",
  "network.integrations.body": "Leverantörer som verkstäderna kan välja för påminnelser till kunder. Bara HQ ser nycklarna, och bara HQ betalar.",
  "network.integrations.unavailable": "Meddelanden är inte påslagna i den här miljön.",
  "network.integrations.email.managed": "Resend · Hanteras av ColorGlo HQ",
  "network.integrations.elks46.username": "API-användarnamn",
  "network.integrations.elks46.password": "API-lösenord",
  "network.integrations.elks46.sender.hint": "3–11 bokstäver eller siffror, utan mellanslag, och börjar med en bokstav, till exempel ColorGlo. Används när verkstaden inte har angett ett eget avsändarnamn.",
  "network.integrations.hint": "Nyckel ••••{hint}",
  "network.integrations.used_by.one": "Används av {count} verkstad",
  "network.integrations.used_by.other": "Används av {count} verkstäder",
  "network.integrations.enabled": "Tillgänglig för verkstäder",
  "network.integrations.enabled.needs_verify": "Testa anslutningen innan leverantören kan slås på.",
  "network.integrations.verify": "Testa anslutning",
  "network.integrations.verified": "Anslutningen fungerar.",
  "network.integrations.send_test": "Skicka test till mig",
  "network.integrations.test_sent": "Testmeddelandet är skickat.",
  "network.integrations.replace": "Byt nycklar",
  "network.integrations.replace.hint": "Leverantören stängs av tills den nya nyckeln har testats.",
  "network.integrations.saved": "Sparat.",
  "network.integrations.failure.credentials_rejected": "Leverantören godkände inte nycklarna.",
  "network.integrations.failure.unreachable": "Leverantören svarade inte. Försök igen om en stund.",
  "network.integrations.failure.unexpected": "Något gick fel hos leverantören.",
  "network.integrations.test_phone": "Mobilnummer för testet",
  "network.integrations.test_phone.hint": "Med landsnummer, till exempel +46701234567.",
  "network.integrations.test_dry_run": "Testläge: inget SMS skickades och inget kostade. Sätt SMS_REDIRECT_TO för att få riktiga test-SMS.",
  "network.integrations.field.sender": "Standardavsändare",
  "network.integrations.field.sender.optional": "Valfritt. 3–11 bokstäver eller siffror. Måste vara godkänt i ert Prelude-konto. Lämna tomt för kontots standard.",
  "network.integrations.field.api_key": "API-nyckel",
  "network.integrations.field.test_template_id": "Mall-ID för testmeddelandet",
  "network.integrations.field.test_template_id.hint": "En mall utan variabler, till exempel template_01k8…. Be Prelude skapa den.",
  "network.integrations.field.access_token": "Åtkomsttoken (permanent systemanvändartoken)",
  "network.integrations.field.phone_number_id": "Telefonnummer-ID",
  "network.integrations.field.phone_number_id.hint": "Siffrorna under WhatsApp → API Setup i Meta, inte själva telefonnumret.",
  "network.integrations.field.test_template_name": "Mall för testmeddelandet",
  "network.integrations.field.test_template_name.hint": "hello_world finns i alla WhatsApp-konton från början.",
  "network.integrations.field.test_template_language": "Mallens språkkod",
  "network.integrations.field.template.booking_confirmed": "Mall-ID: bokningsbekräftelse (colorglo_booking_confirmed)",
  "network.integrations.field.template.reminder": "Mall-ID: påminnelse (colorglo_reminder)",
  "network.integrations.field.template.rescheduled": "Mall-ID: flyttad tid (colorglo_rescheduled)",
  "network.integrations.field.template.cancelled": "Mall-ID: avbokad tid (colorglo_cancelled)",
  "network.integrations.field.template.hint": "Från Prelude efter att mallarna i docs/messaging/prelude-templates.csv har laddats upp. Utan ID skickas inte den typen av meddelande.",
  "network.nav.costs": "Kostnader",
  "network.costs.title": "Meddelandekostnader",
  "network.costs.body": "SMS och WhatsApp per verkstad och månad. Bara HQ ser den här sidan. Belopp i olika valutor räknas aldrig ihop.",
  "network.costs.previous": "Föregående månad",
  "network.costs.next": "Nästa månad",
  "network.costs.sent": "Skickade",
  "network.costs.failed": "Misslyckade",
  "network.costs.skipped": "Överhoppade",
  "network.costs.cost": "Kostnad",
  "network.costs.total": "Totalt {currency}",
  "network.costs.workshop": "Verkstad",
  "network.costs.provider": "Leverantör",
  "network.costs.paused": "Avstängd",
  "network.costs.empty": "Inga SMS eller WhatsApp-meddelanden den här månaden.",
  "network.costs.without_cost": "{count} utan rapporterad kostnad",
  "network.integrations.field.account_sid": "Account SID",
  "network.integrations.field.auth_token": "Auth Token",
  "network.integrations.field.sender.twilio": "Ett avsändarnamn på 3–11 bokstäver eller siffror, till exempel ColorGlo, eller ett Twilio-nummer med landsnummer (+46…). Används när verkstaden inte har angett ett eget.",
  "network.owner.title": "Ägare",
  "network.owner.description": "Inbjudan går till verkstadens egen e-postadress. Ägaren väljer bara ett lösenord.",
  "network.owner.state.none": "Ingen ägare",
  "network.owner.state.invited": "Inbjuden – går ut {date}",
  "network.owner.state.active": "Aktiv",
  "network.owner.send": "Skicka inbjudan",
  "network.owner.resend": "Skicka igen",
  "network.owner.revoke": "Återkalla",
  "network.owner.sent": "Inbjudan skickad till {email}",
  "network.owner.link": "Länken visas bara nu. Dela den om mejlet inte kommer fram.",
  "network.owner.copy": "Kopiera länk",
  "network.owner.copied": "Länken är kopierad",
  "network.owner.error": "Det gick inte. Försök igen."
}
